<template>
  <board-empty-link :emptyLayout="emptyLayout" v-if="boardData.length === 0"></board-empty-link>
  <board-list-link :boardData="boardData" :listLayout="listLayout" v-else></board-list-link>
</template>

<script>
import BoardListLink from "@/components/board/BoardListLink";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import alertMixins from "@/mixins/alertMixins";
import BoardEmptyLink from "@/components/board/BoardEmptyLink";

export default {
  name: "BoardHomeComponent",
  mixins: [boardFilterUtil, boardTemplateUtil, alertMixins],
  components: {BoardEmptyLink, BoardListLink},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardType: '',
  },
  data() {
    return {
      listLayout: '',
      emptyLayout: '',
      getFunc: '',
      listApiParamSet: {},
      boardData: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.getList();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
      this.listLayout = boardTemplateConfig.listLayout;
      this.emptyLayout = boardTemplateConfig.emptyLayout;
      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      this.getFunc = boardFilterConfig.getFunc;
    },
    getList() {
      let params = JSON.parse(JSON.stringify(this.listApiParamSet));
      try {
        this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
          if (res.Info.type != 1) {
            this.errorAlert('게시글 목록을 불러올 수 없습니다.');
            return false;
          }
          this.boardData = res.List;
        })
      } catch (e) {
        this.errorAlert(e);
      }
    },

  },
  watch: {},
}
</script>

<style scoped>

</style>